<template>
  <a class="user-card-toggle-reference" @click="hide">
    <slot></slot>
  </a>
</template>

<script>
    import userCardBus from '../../js/bus/userCardBus'

    export default {
        name: "UserCardToggle",
        props: {
            id: {
                type: String,
                required: true
            }
        },
        mounted() {
            this.reference.addEventListener('mouseenter', this.show);
            this.reference.addEventListener('mouseleave', this.hide);
        },
        methods: {
            show() {
                userCardBus.show(this.id, this.reference.getBoundingClientRect())
            },
            hide() {
                userCardBus.hide();
            },
        },
        computed: {
            reference() {
                return this.$slots.default[0].elm
            }
        },
        destroyed() {
            this.reference.removeEventListener('mouseenter', this.show);
            this.reference.removeEventListener('mouseleave', this.hide);
        }
    }
</script>

<style scoped>
  .user-card-toggle-reference {
    font-size: 0;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/view/userCard/UserCardToggle.vue